"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneBTCClientHmy = void 0;
const tslib_1 = require("tslib");
const OneBtc_1 = require("../out/OneBtc");
const crypto_1 = require("@harmony-js/crypto");
const bitcoinjs_lib_1 = require("bitcoinjs-lib");
const web3_utils_1 = (0, tslib_1.__importDefault)(require("web3-utils"));
const helpers_1 = require("./helpers");
class OneBTCClientHmy {
    constructor(params) {
        this._accountAddress = null;
        this.options = { gasPrice: 1000000000, gasLimit: 6721900 };
        this._useOneWallet = false;
        this._injectSignTransaction = async () => {
            const account = await window.onewallet.getAccount();
            const address = this._prepareAddress(account.address);
            this.contract.wallet.defaultSigner = address;
            this.contract.wallet.signTransaction = async (tx) => {
                tx.from = this._prepareAddress(address);
                return window.onewallet.signTransaction(tx);
            };
        };
        this.getSenderAddress = async () => {
            if (this._useOneWallet) {
                await this._injectSignTransaction();
                const account = await window.onewallet.getAccount();
                return this._prepareAddress(account.address);
            }
            return '';
        };
        this.init = async () => {
            this.contract = this.hmy.contracts.createContract(OneBtc_1.OneBtc.abi, this.contractAddress);
            if (this._useOneWallet) {
                this._injectSignTransaction();
            }
        };
        this.balanceOf = (requesterAddress) => {
            const addressHex = this._prepareAddress(requesterAddress);
            return this.contract.methods.balanceOf(addressHex).call();
        };
        this.cancelIssue = async (requesterAddress, issueId, sendTxCallback) => {
            const addressHex = this._prepareAddress(requesterAddress);
            const senderAddress = await this.getSenderAddress();
            return await this.contract.methods
                .cancelIssue(addressHex, web3_utils_1.default.toBN(issueId))
                .send({
                from: senderAddress,
                gasLimit: this.options.gasLimit,
                gasPrice: this.options.gasPrice,
            })
                .on('transactionHash', sendTxCallback)
                .then(this._responseHandler);
        };
        this.cancelRedeem = async (requesterAddress, redeemId, reimburse = true, sendTxCallback) => {
            const addressHex = this._prepareAddress(requesterAddress);
            const senderAddress = await this.getSenderAddress();
            return await this.contract.methods
                .cancelRedeem(addressHex, web3_utils_1.default.toBN(redeemId), reimburse)
                .send({
                from: senderAddress,
                gasLimit: this.options.gasLimit,
                gasPrice: this.options.gasPrice,
            })
                .on('transactionHash', sendTxCallback)
                .then(this._responseHandler);
        };
        this.getIssueStatus = (requesterAddress, issueId) => {
            const addressHex = this._prepareAddress(requesterAddress);
            return this.contract.methods.getIssueStatus(addressHex, issueId).call();
        };
        this.executeIssue = async (requesterAddress, issueId, btcTxHash, vaultBtcAddress, sendTxCallback) => {
            const btcTx = await this.btcNodeClient.loadBtcTx(btcTxHash);
            const { height, index, hash, hex } = btcTx;
            const txBlock = await this.btcNodeClient.loadBlockByHeight(height);
            const proof = await this.btcNodeClient.loadMerkleProof(hash, height);
            const tx = bitcoinjs_lib_1.Transaction.fromHex(hex);
            const hexForTxId = tx.__toBuffer().toString('hex');
            const senderAddress = await this.getSenderAddress();
            const addressHex = this._prepareAddress(requesterAddress);
            const outputIndex = btcTx.outputs.findIndex((output) => output.address === vaultBtcAddress);
            const heightAndIndex = parseInt((0, helpers_1.getUint32Binary)(height) + (0, helpers_1.getUint32Binary)(index), 2);
            if (outputIndex === -1) {
                throw Error('BTC tx has no valid output');
            }
            return await this.contract.methods
                .executeIssue(addressHex, web3_utils_1.default.toBN(issueId), '0x' + proof, '0x' + hexForTxId, heightAndIndex, '0x' + txBlock.toHex(), outputIndex)
                .send({
                senderAddress,
                gasLimit: this.options.gasLimit,
                gasPrice: this.options.gasPrice,
            })
                .on('transactionHash', sendTxCallback)
                .then(this._responseHandler);
        };
        this.executeRedeem = async (requesterAddress, redeemId, btcTxHash, header, sendTxCallback) => {
            const addressHex = this._prepareAddress(requesterAddress);
            const btcTx = await this.btcNodeClient.loadBtcTx(btcTxHash);
            const { height, index, hash, hex } = btcTx;
            const txBlock = await this.btcNodeClient.loadBlockByHeight(height);
            const proof = await this.btcNodeClient.loadMerkleProof(hash, height);
            const tx = bitcoinjs_lib_1.Transaction.fromHex(hex);
            const hexForTxId = tx.__toBuffer().toString('hex');
            const senderAddress = await this.getSenderAddress();
            return await this.contract.methods
                .executeRedeem(addressHex, web3_utils_1.default.toBN(redeemId), '0x' + proof, '0x' + hexForTxId, height, index, '0x' + txBlock.toHex())
                .send({
                from: senderAddress,
                gasLimit: this.options.gasLimit,
                gasPrice: this.options.gasPrice,
            })
                .on('transactionHash', sendTxCallback)
                .then(this._responseHandler);
        };
        this.getIssueDetails = async (txHash) => {
            const receipt = await this.hmy.blockchain.getTransactionReceipt({
                txnHash: txHash,
            });
            let decoded;
            receipt.result.logs.forEach(async (log) => {
                try {
                    decoded = this.contract.abiCoder.decodeLog([
                        {
                            indexed: true,
                            internalType: 'uint256',
                            name: 'issue_id',
                            type: 'uint256',
                        },
                        {
                            indexed: true,
                            internalType: 'address',
                            name: 'requester',
                            type: 'address',
                        },
                        {
                            indexed: true,
                            internalType: 'address',
                            name: 'vault_id',
                            type: 'address',
                        },
                        {
                            indexed: false,
                            internalType: 'uint256',
                            name: 'amount',
                            type: 'uint256',
                        },
                        {
                            indexed: false,
                            internalType: 'uint256',
                            name: 'fee',
                            type: 'uint256',
                        },
                        {
                            indexed: false,
                            internalType: 'address',
                            name: 'btc_address',
                            type: 'address',
                        },
                    ], log.data, log.topics.slice(1));
                }
                catch (error) {
                    console.log('### error', error);
                }
            });
            return decoded;
        };
        this.getRedeemDetails = async (txHash) => {
            const receipt = await this.hmy.blockchain.getTransactionReceipt({
                txnHash: txHash,
            });
            let decoded;
            receipt.result.logs.forEach((log) => {
                try {
                    decoded = this.contract.abiCoder.decodeLog([
                        {
                            indexed: true,
                            internalType: 'uint256',
                            name: 'redeem_id',
                            type: 'uint256',
                        },
                        {
                            indexed: true,
                            internalType: 'address',
                            name: 'requester',
                            type: 'address',
                        },
                        {
                            indexed: true,
                            internalType: 'address',
                            name: 'vault_id',
                            type: 'address',
                        },
                        {
                            indexed: false,
                            internalType: 'uint256',
                            name: 'amount',
                            type: 'uint256',
                        },
                        {
                            indexed: false,
                            internalType: 'uint256',
                            name: 'fee',
                            type: 'uint256',
                        },
                        {
                            indexed: false,
                            internalType: 'address',
                            name: 'btc_address',
                            type: 'address',
                        },
                    ], log.data, log.topics.slice(1));
                }
                catch (error) {
                    console.log('### error', error);
                }
            });
            return decoded;
        };
        this.getIssueId = async (requesterAddress) => {
            const addressHex = this._prepareAddress(requesterAddress);
            return await this.contract.methods.getIssueId(addressHex).call();
        };
        this.register_vault = async (x, y, sendTxCallback) => {
            const senderAddress = await this.getSenderAddress();
            return await this.contract.methods
                .registerVault(web3_utils_1.default.toBN(x), web3_utils_1.default.toBN(y))
                .send({
                from: senderAddress,
                gasLimit: this.options.gasLimit,
                gasPrice: this.options.gasPrice,
            })
                .on('transactionHash', sendTxCallback)
                .then(this._responseHandler);
        };
        this.requestIssue = async (amount, vaultAddress, oneAmount, sendTxCallback) => {
            const addressHex = this._prepareAddress(vaultAddress);
            const senderAddress = await this.getSenderAddress();
            return await this.contract.methods
                .requestIssue(web3_utils_1.default.toBN(amount), addressHex)
                .send({
                from: senderAddress,
                gasLimit: this.options.gasLimit,
                gasPrice: this.options.gasPrice,
                value: web3_utils_1.default.toBN(oneAmount),
            })
                .on('transactionHash', sendTxCallback)
                .then(this._responseHandler)
                .then((txReceipt) => {
                return this.getIssueDetails(txReceipt.transactionHash);
            });
        };
        this.requestRedeem = async (amountOneBtc, btcAddress, vaultId, sendTxCallback) => {
            const _amountOneBtcBN = web3_utils_1.default.toBN(amountOneBtc);
            const addressHex = this._prepareAddress(vaultId);
            const senderAddress = await this.getSenderAddress();
            return this.contract.methods
                .requestRedeem(_amountOneBtcBN, btcAddress, addressHex)
                .send({
                from: senderAddress,
                gasLimit: this.options.gasLimit,
                gasPrice: this.options.gasPrice,
            })
                .on('transactionHash', sendTxCallback)
                .then(this._responseHandler)
                .then((txReceipt) => {
                return this.getRedeemDetails(txReceipt.transactionHash);
            });
        };
        this.transfer = async (recipient, amount, sendTxCallback) => {
            const amountBN = web3_utils_1.default.toBN(amount);
            const addressHex = this._prepareAddress(recipient);
            const senderAddress = await this.getSenderAddress();
            return this.contract.methods
                .transfer(addressHex, amountBN)
                .send({
                from: senderAddress,
                gasLimit: this.options.gasLimit,
                gasPrice: this.options.gasPrice,
                waitConfirm: true,
            })
                .on('transactionHash', sendTxCallback)
                .on('receipt', (receipt) => {
                console.log('### receipt', receipt);
            })
                .on('error', (err) => {
                console.log('### err', err);
            })
                .then(this._responseHandler);
        };
        this.lockAdditionalCollateral = async (amount, sendTxCallback) => {
            const senderAddress = await this.getSenderAddress();
            return this.contract.methods
                .lockAdditionalCollateral()
                .send({
                value: web3_utils_1.default.toBN(amount),
                from: senderAddress,
                gasLimit: this.options.gasLimit,
                gasPrice: this.options.gasPrice,
            })
                .on('transactionHash', sendTxCallback)
                .then(this._responseHandler);
        };
        this.withdrawCollateral = async (amount, sendTxCallback) => {
            const senderAddress = await this.getSenderAddress();
            return this.contract.methods
                .lockAdditionalCollateral()
                .send({
                value: web3_utils_1.default.toBN(amount),
                from: senderAddress,
                gasLimit: this.options.gasLimit,
                gasPrice: this.options.gasPrice,
            })
                .on('transactionHash', sendTxCallback)
                .then(this._responseHandler);
        };
        this.extendVaultLockPeriod = async (vaultId, lockPeriod, sendTxCallback) => {
            throw new Error('not implemented');
        };
        this.getVaultLockExpireAt = async (vaultId) => {
            throw new Error('not implemented');
        };
        this.lockedVaults = async (vaultId) => {
            throw new Error('not implemented');
        };
        this.updateVaultAccClaimableRewards = async (vaultId) => {
            throw new Error('not implemented');
        };
        this.getClaimableRewards = async (vaultId) => {
            throw new Error('not implemented');
        };
        this.claimRewards = async (vaultId, sendTxCallback) => {
            throw new Error('not implemented');
        };
        this.claimRewardsAndLock = async (vaultId, sendTxCallback) => {
            throw new Error('not implemented');
        };
        this.hmy = params.hmy;
        this.contractAddress = params.contractAddress;
        this.nodeURL = params.nodeURL;
        this.btcNodeClient = params.btcNodeClient;
        this._useOneWallet = params.useOneWallet || false;
        if (params.options) {
            this.options = {
                gasPrice: params.options.gasPrice,
                gasLimit: params.options.gasLimit,
            };
        }
    }
    async setAccount(privateKey) {
        const account = await this.hmy.wallet.addByPrivateKey(privateKey);
        this._accountAddress = account.address;
    }
    getUserAddress() {
        return this._accountAddress;
    }
    getRedeemStatus(requesterAddress, redeemId) {
        const addressHex = this._prepareAddress(requesterAddress);
        return this.contract.methods.getRedeemStatus(addressHex, redeemId).call();
    }
    _prepareAddress(address) {
        return (0, crypto_1.getAddress)(address).checksum;
    }
    _responseHandler(response) {
        if (response.status === 'rejected') {
            throw new Error('transaction rejected');
        }
        return response.transaction.receipt;
    }
    setUseMathWallet(value) {
        return value;
    }
    setUseMetamask(value) {
        return value;
    }
    setUseOneWallet(value) {
        this._useOneWallet = value;
        return value;
    }
}
exports.OneBTCClientHmy = OneBTCClientHmy;
